import { useState, useCallback, forwardRef } from 'react';

import { Icon } from '../icons/Icon';
import { InputText, TInputTextProps } from './InputText';
import { ButtonText } from '../buttons/ButtonText';

export const InputPassword = forwardRef<HTMLInputElement, TInputTextProps>(
  function InputPassword(props, ref) {
    const [type, setType] = useState<'text' | 'password'>('password');
    const switchVisible = useCallback(() => {
      setType(type === 'password' ? 'text' : 'password');
    }, [type, setType]);

    return (
      <InputText {...props} ref={ref} type={type}>
        <ButtonText onClick={switchVisible}>
          <Icon
            color="secondary"
            img={type === 'password' ? 'eye-close' : 'eye'}
          />
        </ButtonText>
      </InputText>
    );
  },
);
